/**
 * 결제 수단 공통 체크 유틸리티
 * @param target 체크할 상품/데이터 배열
 * @param keys 검사할 결제 수단 키 리스트
 * @returns 공통 결제 수단 존재 여부
 */
export const checkCommonPayment = (
    target: any[],
    keys: string[] = ['hcoin', 'pcoin', 'card', 'account']
): boolean => {
    
    if(!target || target.length === 0) return false
    
    return keys.some(key => 
        target.every(item => item.payments?.[key] === true)
    )
}